import jsPDF from "jspdf";
import html2canvas from "html2canvas";

async function buildCoverCanvas(title) {
  const now = new Date();
  const created = now.toLocaleString("tr-TR", {
    day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
  const election = new Date(2026, 9, 11);
  const daysLeft = Math.ceil((election - now) / 86400000);
  const kalan = daysLeft > 0 ? `${daysLeft} gün` : (daysLeft === 0 ? "Bugün" : "Tamamlandı");
  const el = document.createElement("div");
  el.style.cssText =
    "position:fixed;left:-99999px;top:0;width:794px;height:1123px;background:#ffffff;font-family:Arial,'Segoe UI',sans-serif;box-sizing:border-box;";
  el.innerHTML = `
    <div style="background:#0F2C59;padding:56px 40px;text-align:center;margin-top:150px;">
      <div style="color:#ffffff;font-size:40px;font-weight:800;letter-spacing:1px;">İMEAK DTO SEÇİM BÜROSU</div>
      <div style="color:#cbd5e1;font-size:17px;margin-top:12px;">Deniz Ticaret Odası 2026 Seçim Takip Platformu</div>
    </div>
    <div style="text-align:center;padding:0 50px;margin-top:90px;">
      <div style="color:#0F2C59;font-size:38px;font-weight:800;line-height:1.25;">${title}</div>
    </div>
    <div style="display:flex;gap:0;margin:90px 60px 0;border:1px solid #cbd5e1;border-radius:10px;overflow:hidden;">
      <div style="flex:1;text-align:center;padding:22px 10px;border-right:1px solid #e2e8f0;">
        <div style="color:#64748b;font-size:15px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;">Oluşturulma</div>
        <div style="color:#0f172a;font-size:18px;margin-top:10px;">${created}</div>
      </div>
      <div style="flex:1;text-align:center;padding:22px 10px;border-right:1px solid #e2e8f0;">
        <div style="color:#64748b;font-size:15px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;">Seçim Tarihi</div>
        <div style="color:#0f172a;font-size:18px;margin-top:10px;">11 Ekim 2026</div>
      </div>
      <div style="flex:1;text-align:center;padding:22px 10px;">
        <div style="color:#64748b;font-size:15px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;">Seçime Kalan</div>
        <div style="color:#DC2626;font-size:18px;font-weight:700;margin-top:10px;">${kalan}</div>
      </div>
    </div>`;
  document.body.appendChild(el);
  const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", logging: false });
  document.body.removeChild(el);
  return canvas;
}

async function buildPdf(nodes, title) {
  const pdf = new jsPDF("p", "mm", "a4");
  const W = 210, H = 297, M = 10;
  const today = new Date().toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric" });

  const cover = await buildCoverCanvas(title);
  const coverH = (cover.height * W) / cover.width;
  pdf.addImage(cover.toDataURL("image/png"), "PNG", 0, 0, W, Math.min(coverH, H));

  for (const node of nodes) {
    if (!node) continue;
    const canvas = await html2canvas(node, { scale: 2, backgroundColor: "#0b1220", useCORS: true, logging: false });
    const imgW = W - M * 2;
    const imgH = (canvas.height * imgW) / canvas.width;
    pdf.addPage();
    pdf.setFontSize(12);
    pdf.setTextColor(15, 44, 89);
    pdf.text(title, M, M);
    pdf.addImage(canvas.toDataURL("image/png"), "PNG", M, M + 3, imgW, Math.min(imgH, H - M * 2 - 10));
  }
  const pages = pdf.getNumberOfPages();
  for (let p = 2; p <= pages; p++) {
    pdf.setPage(p);
    pdf.setFontSize(8);
    pdf.setTextColor(130);
    pdf.text(today, M, H - 5);
    pdf.text(`Sayfa ${p - 1} / ${pages - 1}`, W - M - 18, H - 5);
  }
  return pdf;
}

export async function downloadPdf(nodes, filename, title) {
  const pdf = await buildPdf(nodes, title);
  pdf.save(filename);
}

export async function sharePdf(nodes, filename, title) {
  const pdf = await buildPdf(nodes, title);
  const blob = pdf.output("blob");
  const file = new File([blob], filename, { type: "application/pdf" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try { await navigator.share({ files: [file], title }); return "shared"; } catch { return "cancel"; }
  }
  pdf.save(filename);
  try { await navigator.clipboard.writeText(window.location.href); } catch { /* ignore */ }
  return "downloaded";
}
